import {EditorState, TextSelection, Transaction} from "prosemirror-state";
import {Node} from "prosemirror-model";
import {schema} from "../../config/schema";
import {EditorView} from "prosemirror-view";
import {TriggerActionCommandAdditionalParams} from "./types";

export const replaceSelectionParagraphWithNode = (state: EditorState, node: Node, noSelection = false) => {
    const { $from } = state.selection;

    let tr  = state.tr.replaceRangeWith($from.before(), $from.after(), node);
    if (!noSelection) {
        tr = setSelectionSafe(tr, tr.mapping.map($from.before()) + (node.isTextblock ? node.nodeSize : 0))
    }
    return tr;
}

export const replaceTextRangeWithNode = (state: EditorState, start: number, end: number, node: Node, noSelection = false) => {
    let tr = state.tr.replaceRangeWith(start, end, node);

    // Set the selection to just after the inserted node
    if (!noSelection) {
        tr = setSelectionSafe(tr, start + node.nodeSize)
    }
    return tr;
}

export const setSelectionSafe = (tr: Transaction, targetPos: number) => {
    if (tr.doc.content.size <= targetPos) {
        targetPos = tr.doc.content.size;
        const paragraphNode = schema.nodes.paragraph.create();
        tr = tr.insert(targetPos, paragraphNode);

        // Resolve the new position after the inserted paragraph
        targetPos = tr.doc.content.size;
    }
    tr = tr.setSelection(TextSelection.near(tr.doc.resolve(targetPos)));

    return tr;
}

export const insertNode = (
    nodeToInsert: Node,
    state: EditorState,
    dispatch?: (tr: Transaction) => void,
    view?: EditorView,
    additionalParams?: TriggerActionCommandAdditionalParams,
) => {
    let tr;
    if ((additionalParams?.nodePos !== undefined) && (additionalParams?.textInput !== undefined)) {
        tr = replaceTextRangeWithNode(state, additionalParams.nodePos, additionalParams.nodePos + additionalParams.textInput.length + 1, nodeToInsert, true);
        tr = setSelectionSafe(tr, additionalParams.nodePos);
    } else {
        tr = replaceSelectionParagraphWithNode(state, nodeToInsert);
    }

    if (tr !== state.tr) {
        if (dispatch && view) {
            dispatch(tr);
            view.focus();
        }
        return true;
    }
    return false;
}
